import './main.css';
import './modal';

import Layout from 'utils/layout';
import Video from 'utils/video';
import getProductPrice from 'utils/globals';

const initSection = (element, layout) => {
  const name = element.dataset.section;
  if (!name) return;

  import(/* webpackChunkName: "[index]" */ `./${name}/index.js`)
    .then((m) => {
      const module = m.default;
      const dataEl = element.querySelector('[data-section-data]');
      // Never let a malformed data island silently blank a whole section.
      // Parse defensively and fall back to {} so the section still mounts and
      // can render its own empty/error state (e.g. ProductModular's "Product
      // unavailable / Refresh" fallback) instead of disappearing.
      let data = {};
      if (dataEl) {
        try {
          data = JSON.parse(dataEl.textContent);
        } catch (err) {
          // eslint-disable-next-line no-console
          console.error(`[section:${name}] failed to parse data island`, err);
        }
      }
      const videoEls = element.querySelectorAll('[data-component="video"]');
      const videos = videoEls && [...videoEls].map((videoEl) => new Video({ element, video: videoEl, layout }));

      if (typeof module === 'function') {
        module(element, { ...data, layout, videos });
      }
    })
    // eslint-disable-next-line no-console
    .catch(console.error);
};

(() => {
  const sections = document.querySelectorAll('[data-section]');
  const layout = Layout.getInstance();

  sections.forEach((element) => initSection(element, layout));

  // Core Web Vitals on every page (SHOPB2C-1072). Lazy, after the section imports have been
  // requested, so the library stays out of main.js and never competes with a section's own chunk.
  // Loading late loses nothing: web-vitals reads buffered performance entries, and the product
  // section registered even later than this before the move.
  import(/* webpackChunkName: "web-vitals" */ 'utils/web-vitals')
    .then((m) => m.registerWebVitals())
    // eslint-disable-next-line no-console
    .catch(console.error);

  document.addEventListener('shopify:section:load', (event) => {
    const container = document.getElementById(`shopify-section-${event.detail.sectionId}`);
    if (!container) return;
    const sectionLayout = Layout.getInstance();
    container.querySelectorAll('[data-section]').forEach((element) => initSection(element, sectionLayout));
  });

  window.getProductPrice = getProductPrice;
  window.dataLayer = window.dataLayer || [];
})();
